// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/OrderTotalDisplaySharedStyles";
import { orderTotalDisplayStyles } from "@steiner/Overrides/Components/OrderTotalDisplay";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

orderTotalDisplayStyles.subtotalLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
orderTotalDisplayStyles.subtotalValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};

orderTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.otherChargesLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.otherChargesValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
orderTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};
orderTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};
orderTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

orderTotalDisplayStyles.container = {
    ...orderTotalDisplaySharedStyles.gridContainer,
};

orderTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
};
orderTotalDisplayStyles.orderSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};
orderTotalDisplayStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
orderTotalDisplayStyles.boxContainer = {
    css: css`
        background-color: ${color("common.ui14")};
    `,
};